<template>
  <FormPanel
      headline="Create Job Region"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentJobRegions/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-job-regions', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The content job region was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/job-regions')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
